import { defineStore } from "pinia";
import { IUser } from "@/package/global-types";
import { BASE_URL } from "@/package/config/axios";
import * as userApi from "@/api/user-api";

export const useUserStore = defineStore("user-store", {
  state: () => ({
    user: null as null | IUser,
  }),

  actions: {
    login() {
      location.href = `${BASE_URL}oauth/rcpassport/redirect`;
    },

    async getUserInformation() {
      try {
        const resp = await userApi.apiGetUser();
        this.user = resp.data.data;
      } catch (e) {
        if (e.response.status === 401) {
          localStorage.removeItem("rcShowToken");
          location.reload();
        }
      }
    },
  },
});
